<template>
    <v-layout class="mt-3">
        <v-flex xs12 class="pl-0">
            <v-card class="mx-aut" flat>
                <confirmation-header-text text="Nepalese Spouse Details/सनाखत गर्ने नेपाली श्रीमान् श्रीमतीको विवरण" class="ml-0"
                                          icon="mdi-human-female-female"/>

                <v-card-text class="pb-0 pt-3">
                    <v-layout row>
                        <v-flex xs12 sm4 class="pr-2">
                            <v-select
                                :items="relations"
                                :rules="[rules.required]"
                                item-text="name"
                                item-value="id"
                                :label="$vuetify.lang.t('$vuetify.gender') + ' *'"
                                outlined
                                v-model="visa.extra.application_data.gender"
                            />
                        </v-flex>

                        <v-flex class="pr-2" xs12 sm4>
                            <v-text-field
                                :label="visa.extra.application_data.married_to?$vuetify.lang.t('$vuetify.full_name') + ' of '+visa.extra.application_data.married_to+' *':$vuetify.lang.t('$vuetify.full_name') + ' of Husband/Wife/Spouse *'"
                                outlined
                                type="text"
                                v-model="visa.extra.application_data.full_name"
                                :rules="[rules.required]"
                            />
                        </v-flex>
                        <v-flex xs12 sm4>
                            <address-auto-complete
                                :label="getDynamicLabel($vuetify.lang.t('$vuetify.address'))"
                                country-code="np"
                                v-model="visa.extra.application_data.full_address"
                                :rules="[rules.required]"
                            />
                        </v-flex>
                        <v-flex class="pr-2" xs12 sm4>
                            <v-text-field
                                :label="getDynamicLabel($vuetify.lang.t('$vuetify.citizenship_number'))"
                                outlined
                                type="text"
                                :rules="[rules.required]"
                                v-model="visa.extra.application_data.citizenship_number"
                            />
                        </v-flex>
                        <v-flex class="pl-3 pr-4" xs12 sm4>
                            <date-picker-nepali
                                v-model="visa.extra.application_data.dob"
                                label="Date of birth (BS)"
                                :min-year="dob.min_year_np"
                                :max-year="dob.max_year_np"
                            />
                        </v-flex>

                        <v-flex xs12 sm4 class="pl-3 pr-4">
                            <date-picker-new
                                v-model="visa.extra.application_data.date_of_marriage"
                                label="Date of marriage (AD) * "
                                :min-year="dob.min_year"
                                :max-year="dob.max_year"
                            />
                        </v-flex>
                        <v-flex xs12 sm4 class="pr-2">
                            <v-text-field
                                outlined
                                :label="$vuetify.lang.t('$vuetify.place_of_marriage')+' *'"
                                v-model="visa.extra.application_data.place_of_marriage"
                                :rules="[rules.required]"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-card-text>

            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import AddressAutoComplete from "../../AddressAutoComplete";
    import ConfirmationHeaderText from "../../ConfirmationHeaderText";
    import FileInput from "../../FileInput";
    import {validationMixin} from "../../../mixins/validationMixin";
    import DatePickerNew from "../../DatePickerNew";
    import DatePickerNepali from "../../DatePickerNepali";

    export default {
        data: () => ({
            relations: ["Male", "Female","Others"],
            options: [
                {
                    text: "Nepal",
                    value: "Nepal"
                },
                {
                    text: "Abroad",
                    value: "Abroad"
                }
            ]
        }),
        components: {
            DatePickerNepali,
            DatePickerNew,
            FileInput, ConfirmationHeaderText,
            "address-auto-complete": AddressAutoComplete
        },
        mixins: [validationMixin],
        computed: {
            visa() {
                return this.$store.state.VisaSingle.visa;
            },
            dob() {
                let max_year = new Date().toISOString().substr(0, 4);
                max_year = parseInt(max_year);
                const min_year = max_year - 120;
                const max_year_np = max_year + 56;
                const min_year_np = max_year_np - 120;
                return {
                    min_year,
                    max_year,
                    min_year_np,
                    max_year_np
                }
            },
        },
        methods: {
            addressChanged(e) {
                this.visa.extra.application_data.address = e;
            },
            getDynamicLabel(text) {
                if (this.visa.extra.application_data.full_name) {
                    return text + ' of ' + this.visa.extra.application_data.full_name + ' *'
                } else if (this.visa.extra.application_data.married_to) {
                    return text + ' of ' + this.visa.extra.application_data.married_to + ' *'
                } else {
                    return text + ' of Husband/Wife/Spouse *'
                }

            },
        }
    };
</script>

<style>
</style>
